import CryptoJS from 'crypto-js';
import storage from './storage';

const SECRET_KEY = 'kpm-trizent-secret-key'; // In production, use environment variable

/**
 * Authentication utility functions
 */

export const auth = {
  /**
   * Encrypt password
   * @param {string} password - Plain text password
   * @returns {string} Encrypted password
   */
  encryptPassword: (password) => {
    return CryptoJS.AES.encrypt(password, SECRET_KEY).toString();
  },

  /**
   * Decrypt password
   * @param {string} encryptedPassword - Encrypted password
   * @returns {string} Decrypted password
   */
  decryptPassword: (encryptedPassword) => {
    const bytes = CryptoJS.AES.decrypt(encryptedPassword, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  },

  /**
   * Set authentication token
   * @param {string} token - Authentication token
   */
  setToken: (token) => {
    storage.setItem('authToken', token);
  },

  /**
   * Get authentication token
   * @returns {string|null} Authentication token or null
   */
  getToken: () => {
    return storage.getItem('authToken');
  },

  /**
   * Remove authentication token
   */
  removeToken: () => {
    storage.removeItem('authToken');
  },

  /**
   * Check if user is authenticated
   * @returns {boolean} True if authenticated, false otherwise
   */
  isAuthenticated: () => {
    const token = auth.getToken();
    const isAuth = storage.getItem('isAuthenticated');
    return !!(token || isAuth);
  },

  /**
   * Set user data
   * @param {object} userData - User information
   */
  setUser: (userData) => {
    storage.setItem('user', userData);
  },

  /**
   * Get user data
   * @returns {object|null} User data or null
   */
  getUser: () => {
    return storage.getItem('user');
  },

  /**
   * Logout user
   */
  logout: () => {
    storage.removeItem('authToken');
    storage.removeItem('user');
    storage.removeItem('isAuthenticated');
  }
};

export default auth;
